import { debounce } from "@sazka/utils/debounce";
class SecondaryMenuSticker {
    static readonly menuSelector = ".sticky-menu";
    static readonly stickyAnchorSelector = ".sticky-menu__anchor";

    _root: JQuery;

    isVisible: boolean;
    breakingPointUnstick: number;

    dropdownEnabled: boolean;

    constructor(root: JQuery) {
        this._root = root;
        this.dropdownEnabled = this._root.data("init-dropdown") as boolean;

        this.calcUnstickOffset();
        this.stickyMenuInit();
        if (this.dropdownEnabled) {
            this.dropdownMenuInit();
        }

        const resizeHandler = debounce(() => {
            this.calcUnstickOffset();
        }, 200);

        window.addEventListener("resize", resizeHandler, { passive: true });
    }

    dropdownMenuInit() {
        // kasicka has one link in menu only for desktop
        const links = this._root.find(".secondary-menu li:not(.d-none) a");
        this._root.addClass(`count-${links.length}`);

        this._root.find(".secondary-menu .highlighted-li a").click(function (e) {
            e.preventDefault();
            if ($(".secondary-menu__placeholder").hasClass("open")) {
                $(".secondary-menu__placeholder").addClass("hiding").removeClass("open");
                setTimeout(function () {
                    $(".secondary-menu__placeholder").removeClass("hiding");
                }, 300);
            } else {
                $(".secondary-menu__placeholder").addClass("open");
            }
        });

        this._root.click(function (e) {
            if (e.target.nodeName.toLowerCase() != "a" && $(".secondary-menu__placeholder").hasClass("open")) {
                $(".secondary-menu__placeholder").addClass("hiding").removeClass("open");
                setTimeout(function () {
                    $(".secondary-menu__placeholder").removeClass("hiding");
                }, 300);
            }
        });
    }

    stickyMenuInit() {
        let lastPos = window.pageYOffset;

        const scrollHandler = () => {
            if (window.pageYOffset < lastPos && this.breakingPointUnstick < window.pageYOffset) {
                if (!this.isVisible) {
                    this.showMenu();
                }
            } else if (this.isVisible) {
                this.hideMenu();
            }

            lastPos = window.pageYOffset;
        };

        window.addEventListener("scroll", scrollHandler, {
            passive: true,
        });
    }

    showMenu() {
        this.isVisible = true;
        this._root.addClass("active");
    }

    hideMenu() {
        this.isVisible = false;
        this._root.removeClass("active");
    }

    calcUnstickOffset() {
        const menuAnchor = $(SecondaryMenuSticker.stickyAnchorSelector).eq(0);
        this.breakingPointUnstick = menuAnchor.offset().top + this._root.height();
    }
}

export function initSecondaryMenuSticker() {
    const menu = $(SecondaryMenuSticker.menuSelector);
    if (menu.length) {
        new SecondaryMenuSticker(menu);
    }
}
